<template>
  <div class="cbaas-operate-param">
    <div v-for="(item, i) in paramList" :key="item + i" class="param-line">
      <el-input
        v-model="item.key"
        class="input-width"
        :disabled="disablePre"
        :placeholder="param[0]"
      ></el-input>
      <el-input
        v-model="item.value"
        class="input-width"
        :placeholder="param[1]"
        :disabled="disablePre"
      ></el-input>
      <div
        v-if="!disablePre"
        :class="['btn-box', i === 0 ? 'add' : 'delete']"
        @click="handleOperate(i)"
      >
        <i v-if="i === 0" class="el-icon-plus"></i>
        <i v-else class="el-icon-delete"></i>
      </div>
      <div v-else class="btn-box-disable">
        <i v-if="i === 0" class="el-icon-plus"></i>
        <i v-else class="el-icon-delete"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    list: {
      type: Array,
      default: () => {
        return [{ key: '', value: '' }]
      }
    },
    disablePre: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    param: {
      type: Array,
      default: () => {
        return ['key', 'value']
      }
    },
    isdisabled: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      paramList: this.list
    }
  },
  methods: {
    clearParam() {
      this.paramList = [{ key: '', value: '' }]
    },
    updateParam(param) {
      this.paramList = param
    },
    handleOperate(i) {
      if (i === 0) {
        this.paramList.push({ key: '', value: '' })
      } else {
        this.paramList.splice(i, 1)
      }
    },
    // 校验使用,是否填写完整
    validateParam() {
      let isEmptyArr = this.paramList.filter(ele => {
        let con1 = this.$utils.isEmpty(ele['key']) && !this.$utils.isEmpty(ele['value'])
        let con2 = !this.$utils.isEmpty(ele['key']) && this.$utils.isEmpty(ele['value'])
        if (con1 || con2) return ele
      })
      return this.$utils.isEmpty(isEmptyArr)
    },
    getParam() {
      //判断只有一行并且数据为空
      let condition =
        this.paramList.length === 1 &&
        (this.$utils.isEmpty(this.paramList[0]['key']) ||
          this.$utils.isEmpty(this.paramList[0]['value']))
      if (condition) {
        return []
      } else {
        //删除数组空的数据
        let newArr = this.paramList.filter((ele, i) => {
          if (
            !this.$utils.isEmpty(this.paramList[i]['key']) &&
            !this.$utils.isEmpty(this.paramList[i]['value'])
          ) {
            return ele
          }
        })
        return newArr
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cbaas-operate-param {
  @include adaptation(());
  .param-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--base-size-8);
    &:last-child {
      margin-bottom: 0;
    }
    .input-width {
      width: calc((100% - var(--base-size-36)) / 2 - var(--base-size-4));
    }
    .btn-box {
      width: var(--base-size-36);
      height: var(--base-size-36);
      line-height: var(--base-size-36);
      text-align: center;
      border-radius: var(--base-border-radius);
      font-size: var(--base-font-size-large);
      border: var(--base-border-width) solid var(--base-border-color-base);
      i {
        font-weight: bolder;
      }

      &:hover {
        opacity: 0.8;
      }
    }
    .btn-box-disable {
      width: var(--base-size-36);
      height: var(--base-size-36);
      line-height: var(--base-size-36);
      text-align: center;
      border-radius: var(--base-border-radius);
      font-size: var(--base-font-size-large);
      border: var(--base-border-width) solid var(--base-border-color-light);
      color: var(--base-color-text-placeholder);
      background: transparent;
      cursor: not-allowed;
      i {
        font-weight: bolder;
      }
    }
    .add {
      background: transparent;
      color: var(--theme-text-color);
    }
    .delete {
      background: transparent;
      color: var(--base-color-danger);
    }
  }
}
</style>
